import { Controller } from 'react-hook-form';
import Select from 'react-select';
import { CountryOption } from 'shared/country.interface';
import React from 'react'
import { FormErrorLabel } from '../Labels/FormErrorLabel'

interface SelectCountryProps {
  control: any;
  errors: any;
  countryOptions: CountryOption[];
}

export const CountrySelector = ({ control, errors, countryOptions }: SelectCountryProps) => {
  return (
    <div className="mb-3">
      <label
        id="select-country-label"
        htmlFor="select-country"
        className="form-label"
      >
        Land
      </label>
      <Controller
        control={control}
        name="country"
        rules={{ required: 'Vennligst velg ditt land.' }}
        render={({ field }) => (
          <Select
            {...field}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                padding: '3.5px 0',
                backgroundColor: 'transparent',
                borderRadius: '0',
                borderColor: state.isFocused ? '#45095a' : '#ced4da',
                boxShadow: 'none',
              }),
              option: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: state.isFocused ? '#fb8caf' : '#fff',
                color: '#45095a',
              }),
            }}
            classNamePrefix="react-select"
            aria-labelledby="select-country-label"
            inputId="select-country"
            options={countryOptions}
            placeholder="Velg ditt land"
          />
        )}
      />
      <FormErrorLabel label={errors.country?.message} />
    </div>
  );
};